import { createTheme } from '@material-ui/core/styles';
import '../assets/fonts/circular/CircularXX-Book.otf';
import '../assets/fonts/circular/CircularXX-Light.otf';
import '../assets/fonts/fonts.css';
import { colors } from './colors';
import { MuiButton } from './styles/MuiButton';
import { MuiCard } from './styles/MuiCard';
import { MuiCardHeader } from './styles/MuiCardHeader';
import { MuiInput } from './styles/MuiInput';
import { MuiInputBase } from './styles/MuiInputBase';
import { MuiPaper } from './styles/MuiPaper';
import { MuiTable } from './styles/MuiTable';
import { MuiTableCell } from './styles/MuiTableCell';
import { MuiTableHead } from './styles/MuiTableHead';
import { MuiTypography } from './styles/MuiTypography';

export function selectTheme() {
  return createTheme({
    palette: {
      primary: {
        main: colors.green,
        light: colors.lightGreen,
      },
    },
    overrides: {
      MuiCssBaseline: {
        '@global': {
          body: {
            backgroundColor: 'white',
          },
        },
      },
      MuiButton,
      MuiTable,
      MuiTableHead,
      MuiTableCell,
      MuiCardHeader,
      MuiInputBase,
      MuiInput,
      MuiCard,
      MuiPaper,
      MuiFormControlLabel: {
        label: {
          fontSize: '0.875rem',
        },
      },
    },
    typography: MuiTypography,
  });
}
